import Table from 'app/components/Table'
import { TableHeader } from 'app/components/Table/types';
import React, { useState, useRef, useEffect } from 'react'
import addIcon from "assets/svgs/ic_plus_primary.svg"
import { TicketGroup, TicketType } from '../types';
import CreateTicketRow from './CreateTicketRow';
import {
	draggable,
	dropTargetForElements,
} from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import AddTicketsDropdown from './AddTicketDropdown';
import TicketLimit from '../containers/Home/components/TicketLimit';
import RowGroupActions from '../containers/Home/components/RowGroupActions';
import { selectDraftBoardForm } from './Settings/redux/selector';
import { useSelector } from 'react-redux';

interface TicketGroupProps {
    icon: React.ReactNode;
    title: string;
    count: number;
    children: React.ReactNode;
    titleClassName?: string;
    headers: TableHeader[];
    color: string;
    onDrop?: (ticketId: string) => void;
    maxCount: number;
    groupStatus:TicketGroup;
    group: TicketGroup;
    showAddTask: boolean;
    selectedType: TicketType;
    onShowAddTask: () => void;
    onCancelAddTask: () => void;
    onChangeTaskType: (type: TicketType) => void;
}

export default function TicketGroups({ 
    icon, 
    title, 
    count, 
    children, 
    titleClassName, 
    headers, 
    color,
    onDrop,
    maxCount,
    groupStatus,
    group,
    showAddTask,
    selectedType,
    onShowAddTask,
    onCancelAddTask,
    onChangeTaskType
}: TicketGroupProps) {
     const [isHovered, setIsHovered] = useState(false);
     const [open, setOpen] = React.useState(false);
    const dropRef = useRef<HTMLDivElement>(null);
    const boardFormData = useSelector(selectDraftBoardForm);
    useEffect(() => {
        if (!dropRef.current) return;
        
        const cleanup = dropTargetForElements({
            element: dropRef.current,
            onDrop: ({ source }) => {
                const ticketId = source.data?.ticketId;
                if (ticketId && onDrop) {
                    onDrop(ticketId as string);
                }
            },
        });

        return () => cleanup();
    }, [onDrop]);

    return (
        <div 
            ref={dropRef}
        >
            <div className='sticky top-0 z-10 bg-[#F4F5F7] border-b border-[#E9ECF2] px-2 py-1'>
                 <div className="flex flex-row items-center gap-[6px] h-[30px]">
                <div className="flex items-center justify-center">
                    {icon}
                </div>
                <p style={{ color: color }} className={`font-medium text-sm leading-[21px] mb-0 mt-[2px] ${titleClassName}`}>
                    {title}
                </p>
                <TicketLimit groupStatus={groupStatus} count={count} maxCount={maxCount} />
                <div>
                <RowGroupActions group={group} />
                </div>
            </div>
            </div>
           
            {(!group?.isCollapse) && (
                <>
                    <Table 
                    headers={headers} 
                    headerClassName="!h-[30px] border-b border-[#E9ECF2]" 
                    tableClassName={`w-[100%]`}
                    >
                    {children}
                    {showAddTask && (
                    <CreateTicketRow 
                        key={group?.groupName}
                        groupId={group?._id}
                        selectedType={selectedType} 
                        setSelectedValue={(type: TicketType) => onChangeTaskType(type)}
                        onCancel={onCancelAddTask}
                        onShowAddTask={()=>onShowAddTask()}
                        groupBy= {boardFormData?.groupBy}
                        defaultGroup={group}
                    />
                    )}
                    </Table>
                     {!showAddTask && (
                             <div
                        className="flex flex-row items-center gap-[4px] mt-[5px] mb-[15px] group hover:bg-[#ECEEF2]"
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        >
                        <div className="flex justify-center items-center size-[20px] cursor-pointer">
                            <img src={addIcon} alt="add" className="size-[20px]" />
                        </div>
                       
                        <div className="flex flex-row items-center group-hover:bg-white group-hover:border group-hover:border-[#E9ECF2] rounded-[4px]">
                            <button
                            onClick={() => onShowAddTask()}
                            className="hover:bg-[#ECEEF2] h-[20px] px-[6px] pb-2 text-sm leading-[21px] font-medium text-primary"
                            >
                            Add task
                            </button>
                            <button
                            className={`${!open ? isHovered ? 'group-hover:visible' : 'invisible' :''} hover:bg-[#ECEEF2] border-l border-[#E9ECF2] justify-center items-center size-[20px] rounded-r-[4px]`}
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpen((prev) => !prev);
                            }}
                            >
                            <AddTicketsDropdown setShowAddTask={(val) => onChangeTaskType(val.type)}
                            open={open}
                            setOpen={setOpen}
                             />
                            </button>
                        </div>
                     </div>
                    )}
            </>
            )}            
        </div>
    )
}

// Helper function to make elements draggable
export function makeTicketDraggable(element: HTMLElement, ticketId: string) {
    return draggable({
        element,
        getInitialData: () => ({ ticketId })
    });
}
